import styled, { css } from 'styled-components'
import { colors } from 'app/theme/colors'
export const Container = styled.div`
  display: flex;
  flex-direction: row-reverse;
  padding: 3px 20px 5px 0;

  .button-dashboard {
    background-color: ${colors.ohOrange};
    text-transform: lowercase;
    font-weight: 600;
    font-family: 'AvenirDemi';
  }

  .button-dashboard:hover {
    background-color: ${colors.ohDarkOrange};
  }
`
